export const DAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// Project identity colours, drawn from the Steel Glass accents: `bg` (the
// accent base) paints borders, dots and bars, `soft` (the accent surface)
// fills, `text` labels on those fills. The system carries six hues plus
// steel, so `sky` and `indigo` reuse the steel and violet families at their
// deeper steps and share the surface with `slate` and `violet`. Keys are
// stored per project in the database, so they never change — only values do.
//
// Identity never uses cyan 400 (`#51e4f7`): that is the brand value, held
// for actions, focus, active and live, and `teal` is the column default, so
// every unlabelled project would have read as selected. It takes the cyan
// *fills* step instead — deep enough to read as data, not interaction.
export const COLOR_SETS = {
  teal: { bg: '#0aa6bd', soft: '#d6f8fe', text: '#07707f' },
  coral: { bg: '#e84fbf', soft: '#fef2fb', text: '#8a1266' },
  violet: { bg: '#b57bff', soft: '#f8f4ff', text: '#5e1ea6' },
  rose: { bg: '#e8455f', soft: '#fff6f7', text: '#c62a44' },
  amber: { bg: '#ffae21', soft: '#fff7e8', text: '#8a5a00' },
  sky: { bg: '#5d7078', soft: '#e8eff2', text: '#0f1e25' },
  lime: { bg: '#46dc46', soft: '#f2fff2', text: '#178017' },
  indigo: { bg: '#5e1ea6', soft: '#f8f4ff', text: '#5e1ea6' },
  slate: { bg: '#8698a0', soft: '#f4f8fa', text: '#3d5259' },
};

// Project tier (1..3); null means the project hasn't been classified yet.
export const PROJECT_TIERS = [1, 2, 3];
